<template>
    <div class="_menu">
        <ul class="tree" id="menu" v-show="!loading">
            <li v-for="(itemLv1, indexLv1) in menu" class="ls_content" :key="indexLv1" @click="goToLesson(itemLv1)">
                <img :src="itemLv1.img"/>
                <span :class="{'active': itemLv1.id == activeID}">{{ itemLv1.chapterName }}</span>
                <ul v-if="itemLv1.childFlag == 1">
                    <li v-for="(itemLv2, indexLv2) in itemLv1.childrens" class="ls_content" :key="indexLv2" @click="goToLesson(itemLv2)">
                        <img :src="itemLv2.img"/>
                        <span :class="{'active': itemLv2.id == activeID}">{{ itemLv2.chapterName }}</span>
                        <ul v-if="itemLv2.childFlag == 1">
                            <li v-for="(itemLv3, indexLv3) in itemLv2.childrens" class="ls_content" :key="indexLv3" @click="goToLesson(itemLv3)">
                                <img :src="itemLv3.img"/>
                                <span :class="{'active': itemLv3.id == activeID}">{{ itemLv3.chapterName }}</span>
                                <ul v-if="itemLv3.childFlag == 1">
                                    <li v-for="(itemLv4, indexLv4) in itemLv3.childrens" class="ls_content" :key="indexLv4" @click="goToLesson(itemLv4)">
                                        <img :src="itemLv4.img"/>
                                        <span :class="{'active': itemLv4.id == activeID}">{{ itemLv4.chapterName }}</span>
                                        <ul v-if="itemLv4.childFlag == 1">
                                            <li v-for="(itemLv5, indexLv5) in itemLv4.childrens" class="ls_content" :key="indexLv5" @click="goToLesson(itemLv5)">
                                                <img :src="itemLv5.img"/>
                                                <span :class="{'active': itemLv5.id == activeID}">{{ itemLv5.chapterName }}</span>
                                            </li>
                                        </ul>
                                    </li>
                                </ul>
                            </li>
                        </ul>
                    </li>
                </ul>
            </li>
        </ul>
        <loading class="loading--lesson" :showLoading="loading" />
    </div>
</template>

<script>
    import { mapState, mapMutations } from "vuex"
    import loading from "@/components/loading/loading"

    export default {
        data() {
            return {
                menu: [],
                activeID: null,
                loading: true
            };
        },
        components: {
            loading, 
        },
        props: {
            course: {
                type: Object,
                default: {},
            }
        },
        created() {
            this.init();

            this.activeID = this.course.activeID;

            // Disabled loading
            this.loading = false;
        },
        computed: {
            ...mapState({
                mobile: (state) => state.header.mobile,
                showMenu: (state) => state.learn.showMenu,
                activeMenuID: (state) => state.learn.activeID,
                reload: (state) => state.learn.reload
            }),
        },
        watch: {
            activeMenuID (value) {
                this.activeID = value;
            },

            reload (value) {
                this.init();
            }
        },
        updated() {
            var tree = document.getElementById("menu");
            if (tree) {
                tree.querySelectorAll("ul").forEach(function (el, key, parent) {
                    var elm = el.parentNode;
                    elm.classList.add("branch");
                    elm.classList.add("collapse");

                    elm.addEventListener("click", function (event) {
                        if (elm === event.target || elm === event.target.parentNode) {
                            if (el.classList.contains("collapse")) {
                                el.classList.add("expand");
                                el.classList.remove("collapse");
                            } else {
                                el.classList.add("collapse");
                                el.classList.remove("expand");
                            }
                        }
                    }, false)
                })
            }
        },
        methods: {
            init: async function () {
                let params = {};
                params.courseId = this.course.id;

                // Get data menu
                let results = await this.getMenu(params);
                this.setMenu(results);
                this.menu = this.convertDataMenu(results);
            },

            // Get data menu
            getMenu: function (params) {
                return new Promise((resolve, reject) => {
                    this.$api
                        .post("/courseStudy/getCourseSubOutlineListByTopOutline", params)
                        .then((response) => {
                            resolve(response.data);
                        })
                        .catch((err) => {
                            reject(err.response);
                        });
                });
            },

            // Convert data
            convertDataMenu: function (data) {
                const self = this;
                let results = [];

                data.forEach((item) => {
                    // Set status lesson
                    item = self.getStatusLesson(item);
                    item.childFlag = 0;

                    let keyParent = data.findIndex((x) => x.id == item.parentId);
                    if (keyParent >= 0) {
                        data[keyParent].childrens = data[keyParent].childrens == null ? [] : data[keyParent].childrens;
                        data[keyParent].childFlag = 1;
                        data[keyParent]['img'] = "../../../static/images/folder-e.png";
                        data[keyParent].childrens.push(item);
                    }
                });

                results = data.filter((x) => {
                    return x.level == 1;
                });

                return results;
            },

            // Get status learn lesson
            getStatusLesson: function (item) {
                let src = "../../../static/images/baihoc-den.png";

                let score = 0;

                item['status'] = 0;

                if (item.score == "—") {
                    if (item.isExercise == 0) {
                        score = 100;
                    }
                } else {
                    score = parseInt(item.score) || 0;
                }
                
                // ---
                if (item.learningState == this.$CONST.VIDEO.MENU.LEARNING) {
                    src = "../../../static/images/baihoc-do.png";
                    item['status'] = 1;
                }

                if (item.learningState == this.$CONST.MENU.LEARNING_COMPLETED && parseInt(item.passingRateQuiz) > score && parseInt(item.isExercise) > 0) {
                    src = "../../../static/images/baihoc-do.png";
                    item['status'] = 1;
                }

                if (item.learningState == this.$CONST.VIDEO.MENU.LEARNING_COMPLETED && item.score == "—" && parseInt(item.questionStatus) == 0 && parseInt(item.isExercise) == 0) {
                    src = "../../../static/images/baihoc-xanhla.png";
                    item['status'] = 2;
                }

                if (item.learningState == this.$CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item.passingRateQuiz) <= score && parseInt(item.questionStatus) == 1 && parseInt(item.isExercise) > 0) {
                    src = "../../../static/images/baihoc-xanhla.png";
                    item['status'] = 2;
                }

                if (item.learningState == this.$CONST.VIDEO.MENU.LEARNING_COMPLETED && parseInt(item.passingRateQuiz) == 0) {
                    src = "../../../static/images/baihoc-xanhla.png";
                    item['status'] = 2;
                }
                // ---

                if (item.score == "—") {
                    if (item.isExercise==0) {
                        item["scoreNew"] = 100;
                    } else {
                        item["scoreNew"] = 0;
                    }
                } else {
                    item["scoreNew"] = parseInt(item.score);
                }

                if (item.learningState == null) {
                    src = "../../../static/images/folder-e.png";
                }

                item['img'] = src;

                return item;
            },

            // Go to lesson
            goToLesson: function (lesson) {
                if (lesson.childFlag == 1 || this.activeID == lesson.id) return;
                this.setActiveID(lesson.id);
                this.init();
                this.activeID = lesson.id;

                if (this.mobile) {
                    this.setShowMenu(!this.showMenu);
                }
            },

            ...mapMutations("learn", ["setActiveID", "setShowMenu", "setMenu"]),
        }
    };
</script>

<style scoped>
    ._menu {
        position: relative;
        min-height: 100%;
        padding-top: 10px;
        font-size: 14px;
        font-weight: 700;
    }
    .loading {
        position: absolute;
        top: 50%;
        left: 50%;
        background-color: rgb(38 50 56 / 0%);
        transform: translate(-50%, -50%);
    }
    .ls_content span.active, .ls_content span:hover {
        color: #0071c5;
    }
    .ls_content img{
        width: 18px;
        height: 18px;
        margin-top: 2px;
        margin-left: 6px;
        float: left;
    }
    .ls_content {
        margin-bottom: 1em;
    }
    .ls_content ul {
        margin-top: 1em;
    }
    .ls_content span {
        width: max-content;
        font-size: 14px !important;
        font-weight: normal !important;
        color: #000;
        font-family: Arial !important;
    }
    .tree {
        margin: 0;
        padding: 0;
        list-style: none;
        cursor: pointer;
    }
    .tree ul{
        margin: 0;
        padding: 0;
        list-style: none;
        margin-left: 1em;
        position: relative;
    }
    .tree ul ul{
        margin-left: .5em;
    }
    .tree ul::before{
        content: "";
        display: block;
        width: 0;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        /* bottom: calc(100% - 14px); */
        border-left: 1px solid;
        border-color: #767b7f33;
    }
    .tree ul li::before{
        content: "";
        display: block;
        width: 10px;
        height: 0;
        border-top: 1px solid;
        border-color: #767b7f33;
        margin-top: -1px;
        position: absolute;
        top: 1em;
        left: 0;
    }
    .tree ul li::last-child::before{
        background: #fff;
        height: auto;
        top: 1em;
        bottom: 0;
    }
    .tree li{
        margin: 0;
        padding: 0 1em;
        padding-right: 0;
        line-height: 2em;
        color: #767b7f33;
        font-weight: 700;
        position: relative;
        display: flex;
    }
    .tree li .expand {
        display: block;
    }
    .tree li .collapse{
        display: none;
    }
    li span{
        color: gray;
        padding-left: 5px;
    }
    .indicator {
        margin-right: 5px;
    }
    .branch {
        display: block !important;
    }
</style>



// WEBPACK FOOTER //
// src/components/learn/menu.vue